const routes = [
  {
    path: 'BFC',
    name: 'BFC',
    component: () => import(/* webpackChunkName: "BFC" */ '@/modules/BFC/index.vue')
  },
];

export default routes;